// src/components/store/sections/blog-posts/BlogV61MinimaljournalLimeZest.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV61MinimaljournalLimeZest(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={61}
      archKey="minimal_journal"
      archLabel="Minimalist Journal Strip"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
